<template>
  <div class="skew" :style="cssProps">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WrapperSkewbg',
  props: {
    bgURL: {
      type: String,
      required: true,
    },
    isSkewed: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cssProps() {
      const skewed = {
        '--imageUrl': `url(${this.bgURL})`,
        '--margintop': '0',
        '--clippath': 'polygon(0 20%, 100% 0, 100% 79%, 0% 100%)',
        '--fullpadding': '150px 0',
      };

      const notSkewed = {
        '--imageUrl': `url(${this.bgURL})`,
        '--margintop': '20px',
        '--clippath': 'none',
        '--fullpadding': '30px 0',
      };
      return this.isSkewed ? skewed : notSkewed;
    },
  },
};
</script>

<style scoped lang="scss">
.skew {
  clip-path: var(--clippath);
  padding: var(--fullpadding);
  margin-top: var(--margintop);

  // background: rgb(41, 152, 255);
  // background-image: linear-gradient(
  //     158deg,
  //     var(--primary-light) 39%,
  //     var(--primary) 88%
  //   ),
  //   var(--imageUrl);

  background-color: hsl(var(--clr-primary-700));
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  width: 100%;

  display: flex;
  justify-content: space-around;
  align-items: center;
  // flex-wrap: wrap;
}

@media (max-width: 1000px) {
  .skew {
    clip-path: none;
    padding: 30px 0;
    margin-top: 20px;
    flex-direction: column;
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .skew {
    flex-direction: column;
  }
}
</style>
